/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var PRC = {};

(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    common: {
      init: function () {
        // JavaScript to be fired on all pages

        PRC.talentTableScrollmagic = function () {
          // init controller
          var loadMoreController = new ScrollMagic.Controller();

          // build scene
          var loadMoreScene = new ScrollMagic.Scene({ triggerElement: '.load-more-results', duration: 10, triggerHook: 'onEnter' })
            .addTo(loadMoreController)
          // .on("update", function (e) {
          //   // console.log('test123 a ');
          // })
          // .on("enter", function (e) {
          //     console.log('test123 b');
          // })
            .on('start', function (e) {
              // console.log('test123 c', e);
              $('.load-more-results').click();
            });
          // .on("progress", function (e) {
          //   // console.log('test123 d');
          // });
        };

        // FONTS
        (function (d) {
          var config = {
            kitId: 'wtw3xqc',
            scriptTimeout: 3000,
            async: true
          };
          var h = d.documentElement; var t = setTimeout(function () { h.className = h.className.replace(/\bwf-loading\b/g, '') + ' wf-inactive'; }, config.scriptTimeout); var tk = d.createElement('script'); var f = false; var s = d.getElementsByTagName('script')[0]; var a; h.className += ' wf-loading'; tk.src = 'https://use.typekit.net/' + config.kitId + '.js'; tk.async = true; tk.onload = tk.onreadystatechange = function () { a = this.readyState; if (f || a && a != 'complete' && a != 'loaded') return; f = true; clearTimeout(t); try { Typekit.load(config); } catch (e) {} }; s.parentNode.insertBefore(tk, s);
        })(document);

        PRC.stickFilters = function () {
          $('#homepage_search').sticky({
            topSpacing: PRC.offset_search
          });
          $('#homepage_search').sticky('update');
        };

        PRC.mobileCheck = function () {
          var check = false;
          if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            check = true;
          } else if (/iPad/i.test(navigator.platform)) {
            check = true;
          }
          return check;
        };

        // PRC.getParam = function(param){
        //   var url_string = window.location.href; //
        //   var url = new URL(url_string);

        //   if(url === null || url == null){
        //     return false;
        //   }else{
        //     return url.searchParams.get(param);
        //   }
        // };

        PRC.getParam = function (parameterName) {
          var result = null;
          var tmp = [];
          location.search
            .substr(1)
            .split('&')
            .forEach(function (item) {
              tmp = item.split('=');
              if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
          return result;
        };

        PRC.activateRowFeatures = function (el) {
          $('.talent-actions__and__demo').not(el.next('.talent-actions__and__demo')).slideUp();

          // $('.talent-actions__and__demo').slideUp();
          $('.talent-row').not(el.parents('.talent-row')).removeClass('actions-open');

          el.parents('.talent-row').find('.talent-actions__and__demo').slideToggle(function () {
            el.parents('.talent-row').toggleClass('actions-open');
          });
        };

        PRC.NavItemHover = function (el) {
          el.addClass('show');
          el.find('a.dropdown-toggle').attr('aria-expanded', 'true');
        };

        PRC.NavItemHoverOff = function (el) {
          el.removeClass('show');
          el.find('a.dropdown-toggle').attr('aria-expanded', 'false');
        };

        PRC.dropTarget = function (el, target, slide) {
          if (!target) {
            target = $(el).attr('data-target');
          }
          $(el, target).toggleClass('active');

          if (slide) {
            $(target).slideToggle(function () {
              if (target == '.filters__container') {
                $('.talent-table__filters').sticky('update');
              }
            });
          }
        };

        PRC.toggleFiltersClose = function (el) {
          $('.talent-table__filters .dropdown-activate').removeClass('active');
          $('.filters__container').removeClass('active').slideUp(function () {
            PRC.stickFilters();
          });
        };

        PRC.scrollToTop = function (scroll_to_el) {
          $('html, body').animate({
            scrollTop: scroll_to_el
          }, 200);
        };

        PRC.activateParallaxSections = function () { // wait for document ready
          // init
          var controller = new ScrollMagic.Controller({
            globalSceneOptions: {
              triggerHook: 'onLeave'
            }
          });

          // get all slides
          var slides = $('.featured-content');

          if ($('.featured-content').length) {
            // create scene for every slide
            for (var i = 0; i < slides.length; i++) {
              new ScrollMagic.Scene({
                triggerElement: slides[i],
                offset: -300,
                duration: 5000
              })
                // .setPin(slides[i])
                //
                .setClassToggle($('.featured-content').get(i), 'active')
                .addTo(controller);
            }
          } else {
            return false;
          }
        };

        PRC.openLines = function () {
          $(this).siblings('.record__line-items').slideToggle();
          $(this).parents('.record').toggleClass('active');
        };

        PRC.searchFocused = function () {
          $('.talent-table__filters').addClass('search-focused');
          if (PRC.tabletSize()) {
            $('.filters__gender, .filters__style, .filters__language, .filters__age, .filters__favs-only').slideUp('fast', function () {
              PRC.stickFilters();
            });
          }
        };

        PRC.searchBlurred = function () {
          $('.talent-table__filters').removeClass('search-focused');
          if (PRC.tabletSize()) {
            $('.filters__gender, .filters__style, .filters__language, .filters__age, .filters__favs-only').slideDown('fast', function () {
              PRC.stickFilters();
            });
          }
        };

        PRC.talentRowExpand = function (e) {
          // $(this).parents('.talent-row').toggleClass('active');
          // $(this).parents('.talent-row').next('.row__secondary').slideToggle();
          // $(this).parents('.talent-row').next('.row__secondary').removeClass('ng-hide');
          // console.log('hi');
          // e.preventDefault();
        };

        PRC.mobileSize = function () {
          if ($(window).width() <= 768) {
            return true;
          } else {
            return false;
          }
        };

        PRC.talentAttributeSizing = function () {
          $('.talent-information-list .terms-inner').each(function () {
            if ($(this).height() >= 80) {
              $(this).parents('.talent-information-list').addClass('toggle-height');
            } else {
              $(this).parents('.talent-information-list').removeClass('toggle-height');
            }
          });
        };

        PRC.tabletSize = function () {
          if ($(window).width() < 992) {
            return true;
          } else {
            return false;
          }
        };

        PRC.offset_filters = 0;

        if (PRC.tabletSize()) {
          PRC.offset_filters = 46;
        } else {
          PRC.offset_filters = 56;
        };

        PRC.stickNav = function () {
          $('.talent-table__filters').sticky({
            topSpacing: 0
          });
          $('.talent-table__filters').sticky('update');
        };

        PRC.activateVolume = function (e) {
          $(this).parents('.player__volume').toggleClass('active');
          e.preventDefault();
        };
      },
      finalize: function () {
        // BIND HOVER EVENTS TO NAV
        if (!PRC.mobileCheck() && !PRC.tabletSize()) {
          $(document).on('mouseover', '.menu-item.dropdown', function () {
            PRC.NavItemHover($(this));
          });
          $(document).on('mouseleave', '.menu-item.dropdown', function () {
            PRC.NavItemHoverOff($(this));
          });
        }

        $(window).resize(function () {
          if (!PRC.mobileCheck() && !PRC.tabletSize()) {
            $(document).on('mouseover', '.menu-item.dropdown', function () {
              PRC.NavItemHover($(this));
            });
            $(document).on('mouseleave', '.menu-item.dropdown', function () {
              PRC.NavItemHoverOff($(this));
            });
          } else {
            $(document).off('mouseover', '.menu-item.dropdown', function () {
              PRC.NavItemHover($(this));
            });
            $(document).off('mouseleave', '.menu-item.dropdown', function () {
              PRC.NavItemHoverOff($(this));
            });
          }
        });

        PRC.talentAttributeSizing();
        // $('.acf-field.prc-timepicker input').timepicker();
        // console.log('param: ' + query.get('active_talent'));
        $('.bar__range').slider({
          slide: function (event, ui) {
            var new_volume = $('.bar__range').slider('option', 'value');
            new_volume = new_volume / 100;
            wavesurfer.setVolume(new_volume);
          }

        }).slider('option', 'value', 50);

        $('.volume__activate').click(PRC.activateVolume);

        // $(document).on('click', '.talent-row__expand > span', PRC.talentRowExpand);

        $('.main-header').sticky();

        if (PRC.tabletSize()) {
          $('.home .talent-table__filters, .page-template.voices .talent-table__filters').sticky({
            topSpacing: PRC.offset_filters,
            wrapperClassName: 'secondary-nav',
            responsiveWidth: true
          });
          $('.account-sidebar').sticky('unstick');
          $('.account-info').sticky({
            topSpacing: 46,
            wrapperClassName: 'account-info-wrapper',
            responsiveWidth: true
          });
        } else {
          $('.home .talent-table__filters, .page-template.voices .talent-table__filters').sticky({
            topSpacing: 56,
            wrapperClassName: 'secondary-nav',
            responsiveWidth: true
          });
          $('.account-sidebar').sticky({
            topSpacing: 175,
            wrapperClassName: 'account-sidebar-wrapper',
            bottomSpacing: $('footer.content-info').height() + 50,
            responsiveWidth: true
          });
          $('.account-info').sticky({
            topSpacing: 63,
            wrapperClassName: 'account-info-wrapper',
            responsiveWidth: true
          });
        }

        $(window).resize(function () {
          if (PRC.tabletSize()) {
            PRC.offset_filters = 46;
          } else {
            PRC.offset_filters = 56;
          };

          PRC.talentAttributeSizing();
          if (PRC.tabletSize()) {
            $('.home .talent-table__filters, .page-template.voices .talent-table__filters').sticky({
              topSpacing: PRC.offset_filters,
              wrapperClassName: 'secondary-nav',
              responsiveWidth: true
            });
            $('.account-sidebar').sticky({
              topSpacing: 136,
              wrapperClassName: 'secondary-nav account-sidebar-wrapper',
              responsiveWidth: true
              // bottomSpacing: $('footer.content-info').height() + 50
            });
            $('.account-info').sticky({
              topSpacing: PRC.offset_filters,
              wrapperClassName: 'account-info-wrapper',
              responsiveWidth: true
            });
            console.log(PRC.offset_filters);
          } else {
            $('.home .talent-table__filters, .page-template.voices .talent-table__filters').sticky({
              topSpacing: PRC.offset_filters,
              responsiveWidth: true
              // wrapperClassName: 'secondary-nav'
            });
            $('.account-sidebar').sticky({
              topSpacing: 175,
              wrapperClassName: 'account-sidebar-wrapper',
              bottomSpacing: $('footer.content-info').height() + 50,
              responsiveWidth: true
            });
            $('.account-info').sticky({
              topSpacing: 63,
              wrapperClassName: 'account-info-wrapper',
              responsiveWidth: true
            });
            console.log(PRC.offset_filters);
          }
          $('.account-info, .account-sidebar, .home .talent-table__filters, .page-template.voices .talent-table__filters').sticky('update');
        });

        if (!PRC.mobileCheck()) {
        } else {
          $('body').addClass('mobile-device');
        }

        $('.formatted-table .record__name').click(PRC.openLines);

        if ($('.featured-content').length) {
          PRC.activateParallaxSections();
        }

        if ($('.swal-content').length) {
          el = $('.swal-content');
          swal(
            el.attr('data-title'),
            el.attr('data-content'),
            'success'
          );
        }

        var form_submitted = false;

        // SWAL FORMS
        if ($('.form--delete-confirm')) {
          $('.actions__delete').on('click', function (e) {
            var form = $(this).prev('form');

            var text = 'Do you really want to delete this?';
            if ($(this).attr('data-mode-contact')) {
              text = $(this).attr('data-mode-contact') + ' will no longer have access to this company.';
            }

            swal({
              title: 'Are you sure?',
              text: text,
              type: 'error',
              showCancelButton: true,
              cancelButtonText: 'Nevermind',
              confirmButtonText: 'Yes'
            }).then(function (result) {
              console.log('hi');
              form.submit();
            });

            e.preventDefault();
          });
        };
        // END SWAL FORMS

        $(document).on('blur', '.search__inner input', function () {
          if (!$('.search__inner input').val()) {
            PRC.searchBlurred();
          }
          // alert('blur');
        });

        $(document).on('focus', '.search__inner input', function () {
          PRC.scrollToTop($('.talent-table').position().top);
          PRC.stickFilters();
          PRC.searchFocused();
        });

        $(document).on('propertychange keyup input paste change', '.search__inner input', function () {
          PRC.scrollToTop($('.talent-table').position().top);
        });

        $(document).on('click', '.activate-row__actions', function (e) {
          PRC.activateRowFeatures($(this));
          e.preventDefault();
        });

        $(document).on('click', '.show-terms', function (e) {
          $(this).closest('.talent-information-list').toggleClass('active');
          e.preventDefault();
        });

        $(document).on('submit', '.dummy-form', function (e) {
          $('.search__inner input').blur();
          PRC.scrollToTop($('.talent-table').position().top);
          if (PRC.tabletSize()) {
            PRC.toggleFiltersClose();
          }
          PRC.stickFilters();
          e.preventDefault();
        });

        $(document).on('click', '.print-link', function (e) {
          window.print();
        });

        $(document).on('mousedown', '.search__clear-icon', function () {
          // alert('CLICKED!');
          $('.search__inner input').val('').trigger('change');
          PRC.scrollToTop($('.talent-table').position().top);
          PRC.searchBlurred();
          PRC.stickFilters();
        });

        $(document).on('change', '.filters__container', function () {
          PRC.scrollToTop($('.talent-table').position().top);
          PRC.stickFilters();
        });

        $(document).on('change', '.filters__container select', function () {
          PRC.scrollToTop($('.talent-table').position().top);
          if (PRC.tabletSize()) {
            PRC.toggleFiltersClose();
          }
          PRC.stickFilters();
        });

        acf.add_action('append', function ($el) {
          $el.find('input').first().focus();
        });

        // $(document).on('click', '.acf-field-repeater .acf-actions .acf-button', function(){
        //   $(this).parents('.acf-field').find('.acf-row').last().find('input').focus();
        // });
        // $('body').click(function(){
        //   $('.talent-actions__and__demo').fadeOut();
        // });

        // skrollr.init();

        $(document).on('click', '.dropdown-activate', function () {
          PRC.dropTarget($(this), false, true);
          if ($(this).attr('data-target') == '.filters__container') {
            PRC.scrollToTop($('.talent-table').position().top);
            $('.talent-table__filters').sticky('update');
          }
        });

        $('.video-content__slider').slick({
          adaptiveHeight: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            },
            {
              breakpoint: 728,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true
              }
            }
          ]
        });

        $('.brands-slider').slick({
          adaptiveHeight: true,
          autoplay: true,
          autoplaySpeed: 10000,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                arrows: false,
                dots: true
              }
            }
          ]
        });

        $('.accordion').accordion({
          heightStyle: 'content'
        });

        if (!PRC.mobileCheck()) {
          $('.featured-banner[data-bg-fixed="true"]').addClass('background-fixed');
        }

        $(document).ready(function () {

        });

        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    home: {
      init: function () {
      // JavaScript to be fired on the home page
      },
      finalize: function () {
        PRC.talentTableScrollmagic();

        // BANNER WAVEFORMS
        PRC.waveForms = {};

        var waveformindex = 0;
        $('.featured-banner__audio').each(function () {
          waveformindex++;
          PRC.waveForms['index_' + waveformindex] = WaveSurfer.create({
            container: '#featured-audio__' + waveformindex,
            waveColor: 'violet',
            progressColor: 'purple',
            height: 50
          });
          PRC.waveForms['index_' + waveformindex].load($(this).attr('data-file'));
        });

        $('.featured-banner__audio-container a').click(function (e) {
          var el_index = $(this).closest('.featured-banner__audio-container').find('.featured-banner__audio').attr('data-index');
          if (PRC.waveForms['index_' + el_index].isPlaying()) {
            PRC.waveForms['index_' + el_index].pause();
          } else {
            for (var waveform in PRC.waveForms) {
              PRC.waveForms[waveform].pause();
            }
            PRC.waveForms['index_' + el_index].play();
          }
          e.preventDefault();
        });

        PRC.waveFormHandlers = function (index) {
          PRC.waveForms[index].on('play', function () {
            $(PRC.waveForms[index].params.container).closest('.featured-banner__audio-container').find('a').addClass('playing');
          });

          PRC.waveForms[index].on('pause', function () {
            $(PRC.waveForms[index].params.container).closest('.featured-banner__audio-container').find('a').removeClass('playing');
          });

          PRC.waveForms[index].on('finish', function () {
            $(PRC.waveForms[index].params.container).closest('.featured-banner__audio-container').find('a').removeClass('playing');
            PRC.waveForms[index].seekTo(0);
          });

          PRC.waveForms[index].on('ready', function () {
            $(PRC.waveForms[index].params.container).closest('.featured-banner__audio-container').find('a').show();
          });
        };

        for (var waveform in PRC.waveForms) {
          var index = 'index_' + $(PRC.waveForms[waveform].params.container).attr('data-index');
          PRC.waveFormHandlers(index);
        }
        // END BANNER WAVEFORMS

        $('.featured-carousel__carousel').slick({
          arrows: true,
          slidesToShow: 5,
          // centerMode: true,
          // variableWidth: true,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4
              }
            },
            {
              breakpoint: 728,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 3
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
        });
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    voices: {
      init: function () {
        // JavaScript to be fired on the about us page
      },
      finalize: function () {
        PRC.talentTableScrollmagic();
      }
    },
    // About us page, note the change from about-us to about_us.
    about_us: {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    },
    get_started: {
      finalize: function () {
        // console.log(PRC.getParam('active_talent'));
        var selection_string = '';
        if (PRC.getParam('active_talent')) {
          selection_string = '.request-purpose #acf-field_59e512ae9ee20-Book-This-Talent';
        }
        if (PRC.getParam('get_pricing')) {
          selection_string = '.request-purpose #acf-field_59e512ae9ee20-Get-a-Custom-Quote';
        }
        $(selection_string).prop('checked', 'checked').change();
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.
